/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
  bearer: string;
};
type HookTuple = [response: vp.AddSignerResponse, AddSigner: (params: vp.AddSignerRequest) => void, reset: () => void];
type ApiHook = (props: HookProps) => HookTuple;

const userPostAddSigner: ApiHook = ({ api, bearer }) => {
  const [shouldAddSigner, setShouldAddSigner] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [params, setParams] = useState<vp.AddSignerRequest>({
    AuthorizedFullLegalName: '',
    AuthorizedEmailAddress: '',
    AuthorizedOccupation: '',
    AuthorizedDOB: '',
    AuthorizedAddress1: '',
    AuthorizedAddress2: '',
    AuthorizedCity: '',
    AuthorizedProvince: '',
    AuthorizedCountry: '',
    AuthorizedPostalCode: '',
  });
  const [response, setResponse] = useState<vp.AddSignerResponse>({
    Success: false,
    ErrorMessage: '',
    Message: '',
    SigningAuthorityID: '',
  });

  useEffect(() => {
    if (!shouldAddSigner) return () => {};

    const AddSigner = async () => {
      setDataFetchingInfo(true, 'Adding Signer', 'fullScreen');
      const res = await api.postAddSigner(params, bearer, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldAddSigner) void AddSigner();
    setShouldAddSigner(false);
    return () => {
      source.cancel();
    };
  }, [shouldAddSigner]);

  return [
    response,
    (_params: vp.AddSignerRequest) => {
      setParams(_params);
      setShouldAddSigner(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Message: '',
        SigningAuthorityID: '',
      });
      setShouldAddSigner(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(userPostAddSigner);
